/* eslint-disable max-len */
import styled, {css} from 'styled-components';
import {breakpoints, mobileMediaQuery} from '../../styles';

export const Container = styled.div`
    width: calc(100% - 80px);
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(16, 1fr);
    margin: 0px 40px;
    grid-gap: 16px;

    & > * {
        width: 100% !important;
        height: 0 !important;
        min-width: initial !important;
        min-height: initial !important;
        padding-bottom: calc(9 / 16 * 100%);
        grid-column: auto / span 4;
    }

    @media screen and (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md}px) {
        grid-template-columns: repeat(12, 1fr);

        & > * {
            grid-column: auto / span 4;
        }
    }

    @media screen and (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.sm}px) {
        grid-template-columns: repeat(12, 1fr);

        & > * {
            grid-column: auto / span 6;
        }
    }

    ${mobileMediaQuery} {
        width: calc(100% - 50px);
        margin: 0px 25px;
        grid-gap: 8px;

        grid-template-columns: repeat(6, 1fr);

        & > * {
            grid-column: auto / span 6;
        }
    }

    ${({cnito}) =>
        cnito &&
        css`
            grid-template-columns: repeat(20, 1fr);

            & > * {
                width: 100% !important;
                height: 0 !important;
                min-width: initial !important;
                min-height: initial !important;
                padding-bottom: calc(224 / 171 * 100%);
                grid-column: auto / span 4;
            }

            @media screen and (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md}px) {
                grid-template-columns: repeat(16, 1fr);

                & > * {
                    padding-bottom: calc(224 / 171 * 100%);
                    grid-column: auto / span 4;
                }
            }

            @media screen and (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.sm}px) {
                grid-template-columns: repeat(12, 1fr);

                & > * {
                    padding-bottom: calc(224 / 171 * 100%);
                    grid-column: auto / span 4;
                }
            }

            ${mobileMediaQuery} {
                width: calc(100% - 50px);
                margin: 0px 25px;
                grid-gap: 8px;

                grid-template-columns: repeat(12, 1fr);

                & > * {
                    grid-column: auto / span 6;
                }
            }
        `}
`;
